import { type CounterTracker, type DescriptionSet} from "./AppState";
import CounterBoard from "./components/CounterBoard";
import DescriptionPanel from "./components/DescriptionPanel";


export default function App({initialCounters, descriptions}: 
    { initialCounters: CounterTracker,
      descriptions: DescriptionSet
    }){
  return (
    <>
      <CounterBoard initialCounters={initialCounters} ></CounterBoard>
      <DescriptionPanel descriptions={descriptions} ></DescriptionPanel>
      </>
  )
}